import type { Content } from '../../interface/Content';
import type { Paginated } from '@/interfaces/Paginate';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getTopContent = async (url: string) => {
  const { data } = await api.get<Paginated<TopContent>>(url, {
    params: { page: 1, limit: 10 },
  });
  return data.data;
};

export const useGetTopContent = () => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.research.topContents
      : apiConfig.routes.research.topContentsPublic;

  return useQuery({
    queryKey: ['top-content', 'research', url],
    queryFn: () => getTopContent(url),
  });
};

export type TopContent = Omit<Content, 'watch'>;
